import { Injectable } from '@angular/core';
import { DialogService } from '@progress/kendo-angular-dialog';
import { PrescriberDetailsModalComponent } from '@module-claims/components/prescriber-details-modal/prescriber-details-modal.component';
import { PrescriberCEAssociationAddParams } from '@module-claims/models/prescriber.interface';
import { ModelModalReturnValue } from '@models-global/model-modal-return-value';
import {
  CEAssociationModalState,
  ICEAssociationModalState
} from '@module-claims/store/ce-association-modal.state';
import { Select } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CeAssociationModalComponent } from '@module-claims/components/ce-association-modal/ce-association-modal.component';
import {
  CEAssociationRemovalModalState,
  ICEAssociationRemovalModalState
} from '@module-claims/store/ce-association-removal-modal.state';
import { CeAssociationRemovalModalComponent } from '@module-claims/components/ce-association-removal-modal/ce-association-removal-modal.component';

type CEAssociationModalReturn =
  ModelModalReturnValue<PrescriberCEAssociationAddParams>;
type CEAssociationRemovalModalReturn =
  ModelModalReturnValue<PrescriberCEAssociationAddParams>;

@Injectable()
export class PrescriberModalService {
  constructor(private _dialogService: DialogService) {}

  open(npi?: string, title = 'Prescriber Details'): void {
    const modalRef = this._dialogService.open({
      title,
      content: PrescriberDetailsModalComponent
    });
    modalRef.content.instance.npi = npi;
  }
}

@Injectable()
export class CEAssociationModalService {
  @Select(CEAssociationModalState)
  stateModal$!: Observable<ICEAssociationModalState>;

  constructor(private _dialogService: DialogService) {}

  open(
    npi: string,
    title = 'Add Covered Entity Association'
  ): Observable<CEAssociationModalReturn> {
    const modalRef = this._dialogService.open({
      title,
      content: CeAssociationModalComponent
    });
    modalRef.content.instance.npi = npi;

    const data$ = new Subject<CEAssociationModalReturn>();
    this.stateModal$.pipe(filter((data) => !!data)).subscribe((data) => {
      data$.next({
        action: data.action,
        data: data.data,
        modalRef
      });
    });

    return data$;
  }
}

@Injectable()
export class CEAssociationRemovalModalService {
  @Select(CEAssociationRemovalModalState)
  stateModal$!: Observable<ICEAssociationRemovalModalState>;

  constructor(private _dialogService: DialogService) {}

  open(
    npi: string,
    title = 'Add Covered Entity Association'
  ): Observable<CEAssociationModalReturn> {
    const modalRef = this._dialogService.open({
      title,
      content: CeAssociationRemovalModalComponent
    });
    modalRef.content.instance.npi = npi;

    const data$ = new Subject<CEAssociationRemovalModalReturn>();
    this.stateModal$.pipe(filter((data) => !!data)).subscribe((data) => {
      data$.next({
        action: data.action,
        data: data.data,
        modalRef
      });
    });

    return data$;
  }
}
